import React from "react";
import { LegacyEmailComponentType } from "./EmailComponents.type";
import { FileCard } from "components/RFQ/FileCard";

export const SupplierAwardedEmailContent: React.FC<
	LegacyEmailComponentType
> = ({
	projectTitle,
	companyName,
	currentCompanyName,
	additionalMessage,
	attachment,
}) => {
	return (
		<div>
			<svg
				width="664"
				height="224"
				viewBox="0 0 664 224"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0_36_30)">
					<path
						d="M0 16C0 7.16345 7.16344 0 16 0H648C656.837 0 664 7.16344 664 16V224H0V16Z"
						fill="#003CE9"
					/>
					<path
						d="M667.718 -241C680.248 -161.57 663.646 15.6318 497 89"
						stroke="#708FFB"
						stroke-width="1.5"
					/>
					<circle
						cx="497"
						cy="89"
						r="7"
						fill="#4864F9"
					/>
					<path
						d="M326 70L332 76L352 56M340 54H323.6C320.24 54 318.56 54 317.276 54.654C316.147 55.2292 315.229 56.1471 314.654 57.2761C314 58.5595 314 60.2397 314 63.6V80.4C314 83.7603 314 85.4405 314.654 86.7239C315.229 87.8529 316.147 88.7708 317.276 89.346C318.56 90 320.24 90 323.6 90H340.4C343.76 90 345.44 90 346.724 89.346C347.853 88.7708 348.771 87.8529 349.346 86.7239C350 85.4405 350 83.7603 350 80.4V72"
						stroke="#DEEBFF"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M137.518 164V118.4H150.838L154.438 122V140.96L151.258 144.14L154.858 164H149.278L145.738 144.56H143.278V164H137.518ZM147.478 139.88L148.678 138.68V124.4L147.478 123.2H143.278V139.88H147.478ZM171.334 118.4V123.32H163.054V138.98H170.494V143.9H163.054V164H157.294V118.4H171.334ZM183.832 140.78L190.612 164H184.852L180.832 149.24L176.992 164H171.472L178.252 140.78L171.772 118.4H177.532L181.192 132.68L184.792 118.4H190.312L183.832 140.78ZM209.647 131.6V124.4L208.447 123.2H206.347L205.147 124.4V137.24L206.347 138.44H211.987L215.587 142.04V160.4L211.987 164H202.867L199.267 160.4V150.86H205.027V158L206.227 159.2H208.627L209.827 158V144.56L208.627 143.36H202.987L199.387 139.76V122L202.987 118.4H211.807L215.407 122V131.6H209.647ZM234.626 160.4L231.026 164H221.366L217.766 160.4V118.4H223.526V157.88L224.726 159.08H227.666L228.866 157.88V118.4H234.626V160.4ZM250.63 118.4L254.23 122V137.12L250.63 140.72L254.23 144.32V160.4L250.63 164H237.31V118.4H250.63ZM247.27 138.44L248.47 137.24V124.4L247.27 123.2H243.07V138.44H247.27ZM247.27 143.24H243.07V159.08H247.27L248.47 157.88V144.44L247.27 143.24ZM272.096 164H266.396L261.896 128.24V164H256.676V118.4H265.016L269.276 155.24L273.536 118.4H282.056V164H276.596V128.24L272.096 164ZM284.832 164V118.4H290.592V164H284.832ZM303.198 131.6V124.4L301.998 123.2H299.898L298.698 124.4V137.24L299.898 138.44H305.538L309.138 142.04V160.4L305.538 164H296.418L292.818 160.4V150.86H298.578V158L299.778 159.2H302.178L303.378 158V144.56L302.178 143.36H296.538L292.938 139.76V122L296.538 118.4H305.358L308.958 122V131.6H303.198ZM321.217 131.6V124.4L320.017 123.2H317.917L316.717 124.4V137.24L317.917 138.44H323.557L327.157 142.04V160.4L323.557 164H314.437L310.837 160.4V150.86H316.597V158L317.797 159.2H320.197L321.397 158V144.56L320.197 143.36H314.557L310.957 139.76V122L314.557 118.4H323.377L326.977 122V131.6H321.217ZM329.396 164V118.4H335.156V164H329.396ZM354.962 122V160.4L351.362 164H341.342L337.742 160.4V122L341.342 118.4H351.362L354.962 122ZM348.002 123.32H344.702L343.502 124.52V157.88L344.702 159.08H348.002L349.202 157.88V124.52L348.002 123.32ZM357.523 164V118.4H363.763L370.363 150.02V118.4H375.583V164H369.343L362.743 132.86V164H357.523ZM396.918 152.24H391.638L390.498 164H384.738L390.198 118.4H398.478L404.058 164H398.058L396.918 152.24ZM396.498 147.32L394.278 124.34L392.058 147.32H396.498ZM429.719 164H421.919L418.799 125.6L415.679 164H407.639L401.819 118.4H407.819L411.239 157.82L415.259 118.4H422.459L426.479 157.82L429.899 118.4H435.539L429.719 164ZM445.494 152.24H440.214L439.074 164H433.314L438.774 118.4H447.054L452.634 164H446.634L445.494 152.24ZM445.074 147.32L442.854 124.34L440.634 147.32H445.074ZM453.945 164V118.4H467.265L470.865 122V140.96L467.685 144.14L471.285 164H465.705L462.165 144.56H459.705V164H453.945ZM463.905 139.88L465.105 138.68V124.4L463.905 123.2H459.705V139.88H463.905ZM487.221 118.4L490.821 122V160.4L487.221 164H473.721V118.4H487.221ZM483.861 159.08L485.061 157.88V124.52L483.861 123.32H479.481V159.08H483.861ZM493.381 164V118.4H507.601V123.32H499.141V138.44H506.521V143.36H499.141V159.08H507.721V164H493.381ZM523.083 118.4L526.683 122V160.4L523.083 164H509.583V118.4H523.083ZM519.723 159.08L520.923 157.88V124.52L519.723 123.32H515.343V159.08H519.723Z"
						fill="white"
					/>
					<path
						d="M-82 31L80 194"
						stroke="#708FFB"
						stroke-width="1.5"
					/>
					<circle
						cx="80"
						cy="194"
						r="7"
						fill="#4864F9"
					/>
				</g>
				<defs>
					<clipPath id="clip0_36_30">
						<path
							d="M0 16C0 7.16345 7.16344 0 16 0H648C656.837 0 664 7.16344 664 16V224H0V16Z"
							fill="white"
						/>
					</clipPath>
				</defs>
			</svg>

			<div className="my-10">
				<p className="py-5">Dear {companyName || "Participant's"},</p>
				<div className="space-y-3">
					<p>
						{currentCompanyName ? currentCompanyName : "Client"} are delighted
						to inform you that {companyName} has been selected as the successful
						service provider for the RFx regarding {projectTitle}. Your
						submission has been thoroughly reviewed, and we are pleased to award
						you the scope to help us deliver this project as per the terms and
						conditions outlined in the contract.
					</p>
					<p>Additional information from client:</p>
					<p>{additionalMessage}</p>
					<p>
						The project owner will be in touch with you shortly to kick start
						the project and discuss the next steps.
					</p>
					<p>
						Congratulations once again, and we look forward to a successful
						collaboration.
					</p>
				</div>
			</div>
			{attachment?.length > 0 && (
				<p className="font-semibold">
					Attachment {/* @ts-ignore */}
					<FileCard
						file={attachment[0]}
						isPreview
					/>
				</p>
			)}
		</div>
	);
};
